export default __webpack_public_path__ + "static/media/SX-logo.5dd4760f.png";